import React from 'react';
import { Grid } from '@mui/material';

import { BooleanDescField, CurrencyTextField, RatingField, TagsSelectField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function OpportunitiesDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="oppo_tags"
					label={t('DETAILS_OPPORTUNITIES_FIELD_TAGS')}
					value={props.model.oppo_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* WARNING */}
				<BooleanDescField
					name="oppo_warning_desc"
					label={t('DETAILS_OPPORTUNITIES_FIELD_WARNING')}
					value={props.model.oppo_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* BLOCKED */}
				<BooleanDescField
					name="oppo_blocked_desc"
					label={t('DETAILS_OPPORTUNITIES_FIELD_BLOCKED')}
					value={props.model.oppo_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* PLANNED VALUE */}
				<CurrencyTextField
					name="oppo_value_planned"
					label={t('DETAILS_OPPORTUNITIES_FIELD_PLANNEDVALUE')}
					value={props.model.oppo_value_planned}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* EXPENSES */}
				<CurrencyTextField
					name="oppo_expenses"
					label={t('DETAILS_OPPORTUNITIES_FIELD_EXPENSES')}
					value={props.model.oppo_expenses}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* RATING */}
				<RatingField
					name="oppo_rating"
					label={t('DETAILS_OPPORTUNITIES_FIELD_RATING')}
					value={props.model.oppo_rating}
					icon="fire"
					emptyIcon="dot"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
